export default "__VITE_ASSET__Dl6ORi80__"